export enum MerchantStatusEnum {
  Sent = 1,
  Draft = 2,
  ApprovedCompanyDetail = 3,
  ApprovedAuthorizedRepresentative = 4,
  DocumentUploaded = 5,
  ForApproval = 6,
  RejectedInitialOnboarding = 7,
  ForPartnerSignature = 8,
  WelcomePage = 9,
  // Ongoing setup
  StoreCreation = 10,
  CreatedStore = 11,
  AddedProducts = 12,
  AddedEmployees = 13,
  AddedPayment = 14,
  MerchantStoreSubmitted = 15,
  // End of on going setup

  // Start of Final review
  FinalReview = 16,
  OnGoingFinalReview = 17,
  RejectedFinalReview = 18,
  OnboardingCompleted = 19,
  // End of final review
  Activated = 20,
}
